/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramCategoryControllerGetTreeMultilanguageQueryResponse } from '../../types/TelegramCategoryControllerGetTreeMultilanguage.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramCategoryGetTreeMultilanguage } from '../../methods/telegramCategoryGetTreeMultilanguage.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramCategoryGetTreeMultilanguageQueryKey = () =>
  [{ url: '/api/telegram/category/tree/multilanguage' }] as const;

export type TelegramCategoryGetTreeMultilanguageQueryKey = ReturnType<
  typeof telegramCategoryGetTreeMultilanguageQueryKey
>;

export function telegramCategoryGetTreeMultilanguageQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramCategoryGetTreeMultilanguageQueryKey();
  return queryOptions<
    TelegramCategoryControllerGetTreeMultilanguageQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramCategoryControllerGetTreeMultilanguageQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramCategoryGetTreeMultilanguage(config);
    },
  });
}

/**
 * {@link /api/telegram/category/tree/multilanguage}
 */
export function useTelegramCategoryGetTreeMultilanguage<
  TData = TelegramCategoryControllerGetTreeMultilanguageQueryResponse,
  TQueryData = TelegramCategoryControllerGetTreeMultilanguageQueryResponse,
  TQueryKey extends QueryKey = TelegramCategoryGetTreeMultilanguageQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramCategoryControllerGetTreeMultilanguageQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramCategoryGetTreeMultilanguageQueryKey();

  const query = useQuery(
    {
      ...telegramCategoryGetTreeMultilanguageQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
